import { render, staticRenderFns } from "./ChargesTab.vue?vue&type=template&id=a3025a42&scoped=true&"
import script from "./ChargesTab.vue?vue&type=script&lang=js&"
export * from "./ChargesTab.vue?vue&type=script&lang=js&"
import style0 from "./ChargesTab.vue?vue&type=style&index=0&id=a3025a42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3025a42",
  null
  
)

export default component.exports